import { ReactElement } from 'react';

import { PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { StyledPatientPresenceField } from './PatientPresenceField.styled';
import {
   usePatientPresenceFilterSearchParamHandler,
   usePatientPresenceTriggerLabelExtractor,
} from './PatientPresenceField.hooks';
import { PATIENT_PRESENCE_ID_MAP } from './PatientPresenceField.utils';

type PatientPresenceFieldFormBeanPart = {
   patientPresences: PatientPresence[];
};

type PatientPresenceFieldProps = {
   register: BindingCreator<PatientPresenceFieldFormBeanPart, 'patientPresences'>;
   currentFilters: PatientPresence[];
};

const items = Object.keys(PATIENT_PRESENCE_ID_MAP) as PatientPresence[];

export const PatientPresenceField = (props: PatientPresenceFieldProps): ReactElement => {
   return (
      <StyledPatientPresenceField>
         <Multiselect<PatientPresence>
            testId={'patientPresences'}
            triggerLabelExtractor={usePatientPresenceTriggerLabelExtractor()}
            placeholder={appointmentsTranslationKeys.patientPresenceStatusFilter.selectPatientPresenceStatuses}
            controller={props.register('patientPresences')}
            onHide={usePatientPresenceFilterSearchParamHandler(props.currentFilters)}
         >
            <>
               <Multiselect.SelectAll<PatientPresence>
                  testId={'selectAllPatientPresences'}
                  items={items}
                  selectAllLabel={appointmentsTranslationKeys.patientPresenceStatusFilter.selectAll}
               />
               <Multiselect.List items={items}>
                  {(item) => (
                     <Multiselect.Item
                        item={item}
                        testId={item}
                        label={appointmentsTranslationKeys.patientPresenceMap[item]}
                     />
                  )}
               </Multiselect.List>
            </>
         </Multiselect>
      </StyledPatientPresenceField>
   );
};
